
import Cell from 'vux/src/components/cell/index.vue'

import  Details  from "./details.vue";

export default {
name:'monthly',
data() {
return {
show: false
}
},
components: {
Cell,
Details
},
props: {
src: {
type: String,
default: ''
},
},
methods: {
details() {
this.STATISTICS_CONFIG.insur_proinfo_paymonthinfo_click()
this.show = false;
this.$nextTick(()=>{
this.show = true
})
},
},
}

